var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAccessibilityOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 15C43.4518 15 46.25 12.2018 46.25 8.75C46.25 5.29822 43.4518 2.5 40 2.5C36.5482 2.5 33.75 5.29822 33.75 8.75C33.75 12.2018 36.5482 15 40 15Z",
    stroke: "#FF5B00",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M31.9109 42.8809C32.364 40.059 32.5671 37.3309 31.8327 35.445C31.2077 33.8231 29.8484 32.9153 28.2077 32.2965L13.7499 27.6184C11.8749 26.9934 10.1234 25.9465 9.99993 23.8778C9.84368 21.2215 12.1874 19.5028 14.5312 20.1278C14.5312 20.1278 28.2812 24.9934 39.9999 24.9934C51.7187 24.9934 65.3124 20.1497 65.3124 20.1497C68.1249 19.3684 69.9999 21.5559 69.9999 23.8668C69.9999 26.0872 68.2812 26.8684 66.2499 27.6075L52.4999 32.5934C51.2499 33.0622 49.2187 33.9997 48.4374 35.434C47.4999 37.1137 47.6562 40.0481 48.1093 42.87L49.0312 47.4997L54.8765 73.109C55.314 75.1637 53.8921 77.084 51.8452 77.4434C49.7984 77.8028 48.1249 76.4059 47.5187 74.4184L41.6499 56.3044C41.3676 55.4356 41.1176 54.557 40.8999 53.6684L39.9999 49.9997L39.1718 53.3825C38.9093 54.4606 38.6072 55.5273 38.2656 56.5825L32.4999 74.4028C31.8749 76.4106 30.2343 77.8012 28.1874 77.4434C26.1405 77.0856 24.6874 75.0075 25.1468 73.109L30.989 47.5106L31.9109 42.8809Z",
    stroke: "#FF5B00",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccessibilityOutline);
export default __webpack_public_path__ + "static/media/accessibility-outline.8247c666e87bd68dc6134d0355beb283.svg";
export { ForwardRef as ReactComponent };